// Shared DOC (days-of-cover) semantic scale — the single source of truth for the red/amber/green
// health thresholds and the MUI colour tokens they map to. Extracted verbatim from
// BundleToolTables.tsx so the Simple/Bundle table rows and the Bundle Catalog detail view read a
// given SKU identically. Do NOT change the thresholds or returned colour tokens here without
// intending to change every consumer.

export const DOC_THRESHOLD_RED = 7;       // < 7  → red (bundle view)
export const DOC_THRESHOLD_AMBER = 20;    // < 20 → amber
export const DOC_COMP_RED = 15;           // < 15 → red (component view)
export const DOC_COMP_TARGET = 60;        // matches TARGET_DOC; >= 60 → green

export const docColorBundle = (doc: number | null | undefined): 'error' | 'warning' | 'success' | 'default' => {
    if (doc === null || doc === undefined) return 'default';
    if (doc < DOC_THRESHOLD_RED) return 'error';
    if (doc < DOC_THRESHOLD_AMBER) return 'warning';
    return 'success';
};

export const docColorComponent = (doc: number | null | undefined): 'error' | 'warning' | 'success' | 'default' => {
    if (doc === null || doc === undefined) return 'default';
    if (doc < DOC_COMP_RED) return 'error';
    if (doc < DOC_COMP_TARGET) return 'warning';
    return 'success';
};
